import { ICON_DEFAULT_COLOR } from '@constants/icons';
import { IconProps } from '@models/icons';

function CustomerServiceIcon({ size = 16, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <g transform="translate(1.3333 2)">
                <path d="M12.6667 6.14667C12.6667 2.48667 9.82667 0 6.66667 0C3.54 0 0.666667 2.43333 0.666667 6.18667C0.266667 6.41333 0 6.84 0 7.33333V8.66667C0 9.4 0.6 10 1.33333 10H2V5.93333C2 3.35333 4.08667 1.26667 6.66667 1.26667C9.24667 1.26667 11.3333 3.35333 11.3333 5.93333V10.6667H6V12H11.3333C12.0667 12 12.6667 11.4 12.6667 10.6667V9.85334C13.06 9.64667 13.3333 9.24 13.3333 8.76V7.22667C13.3333 6.76 13.06 6.35333 12.6667 6.14667Z"
                    fill={color}/>
                <path d="M4.66659 7.33332C5.03478 7.33332 5.33326 7.03484 5.33326 6.66665C5.33326 6.29846 5.03478 5.99999 4.66659 5.99999C4.2984 5.99999 3.99993 6.29846 3.99993 6.66665C3.99993 7.03484 4.2984 7.33332 4.66659 7.33332Z"
                    fill={color}/>
                <path d="M8.66652 7.33332C9.03471 7.33332 9.33319 7.03484 9.33319 6.66665C9.33319 6.29846 9.03471 5.99999 8.66652 5.99999C8.29833 5.99999 7.99986 6.29846 7.99986 6.66665C7.99986 7.03484 8.29833 7.33332 8.66652 7.33332Z"
                    fill={color}/>
                <path d="M10.6673 5.3533C10.5083 4.41606 10.0229 3.56528 9.29693 2.95156C8.57096 2.33783 7.65126 2.00075 6.70063 1.99997C4.68063 1.99997 2.5073 3.6733 2.68063 6.29997C3.50288 5.96382 4.22911 5.42929 4.79446 4.74411C5.35982 4.05893 5.74673 3.24443 5.92063 2.3733C6.79396 4.12664 8.5873 5.3333 10.6673 5.3533Z"
                    fill={color}/>
            </g>
        </svg>
    );
}

export default CustomerServiceIcon;
